<!-- 结构:Page -->
<template>
  <div class="homeTemp"  >
    <!-- Page -->
    <v-page :page-val="homeData"></v-page>
  </div>
</template>

<script>
import { interfaceObj } from "@/urlConfig";
import page from "@/components/page"

export default {
  name: "homeTemp",
  components:{
    "v-page":page,//块组件
  },
  data() {
    return {
      md:"## * HelloWorld *",
      defaultOpen:"preview",
      loading:true,//加载中
      homeData:{},//首页全部数据
      defaultActive: '1',
      pageData:{
        head:[{
                "name": "首页",
                "path": "/index/home",
                "icon": "icon iconfont icon-home",
                "key": false,
                "son": []
              },
              {
                "name": "产品",
                "path": "/index/orders",
                "icon": "icon iconfont icon-order",
                "key": true,
                "son": [
                  {
                    "name": "订单审核",
                    "path": "/index/orders/orderCheck",
                    "icon": "icon iconfont icon-dui"
                  },
                  {
                    "name": "财务审核",
                    "path": "/index/orders/finanCheck",
                    "icon": "icon iconfont icon-dui"
                  },
                  {
                    "name": "全部订单",
                    "path": "/index/orders/allOrders",
                    "icon": "icon iconfont icon-dui"
                  }
                ]
              },
              {
                "name": "认证服务",
                "path": "/index/seller",
                "icon": "icon iconfont icon-shangjia",
                "key": true,
                "son": [
                  {
                    "name": "解决方案",
                    "path": "/index/seller/business",
                    "icon": "icon iconfont icon-dui"
                  }
                ]
              },
              {
                "name": "解决方案",
                "path": "/index/power",
                "icon": "icon iconfont icon-yuechi",
                "key": false,
                "son": []
              },
              {
                "name": "合作案例",
                "path": "/index/finanCount",
                "icon": "icon iconfont icon-caiwu",
                "key": false,
                "son": []
              },
              {
                "name": "合作伙伴",
                "path": "/index/finanCount",
                "icon": "icon iconfont icon-caiwu",
                "key": false,
                "son": []
              },
              {
                "name": "关于我们",
                "path": "/index/finanCount",
                "icon": "icon iconfont icon-caiwu",
                "key": false,
                "son": []
              }],
        blockdata:[
          {type:1,data:[]},
          // {type:4,data:{
          //     "title":"远程云教育平台文章类型",
          //     "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
          //     "place":2,//结构0图上 1图下 2图左 3图右
          //     "type":0,//0默认 1圆角
          //     "list":[
          //     {
          //       "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          //       "content":"搭建企业大学，构建SASS云学院1"
          //     },
          //     {
          //       "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          //       "content":"搭建企业大学，构建SASS云学院2"
          //     },
          //     {
          //       "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          //       "content":"搭建企业大学，构建SASS云学院3"
          //     },
          //     {
          //       "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          //       "content":"搭建企业大学，构建SASS云学院4"
          //     },
          //     ]
          //   }
          // },
          {type:3,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":1,//结构0图上 1图下 2图左 3图右
              "type":0,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院1"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院2"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院3"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院4"
              },
              ]
            }
          },
          {type:3,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":2,//结构0图上 1图下 2图左 3图右
              "type":0,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院1"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院2"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院3"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院4"
              },
              ]
            }
          },
          {type:2,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":0,//结构0图上 1图下 2图左 3图右
              "type":1,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院2"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院3"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院4本学院简介仅供参考"
              }
              ]
            }
          },
          {type:2,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":1,//结构0图上 1图下 2图左 3图右
              "type":0,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院2"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院3"
              },
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院4本学院简介仅供参考"
              }
              ]
            }
          },
          {type:2,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":2,//结构0图上 1图下 2图左 3图右
              "type":0,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院"
              },
              ]
            }
          },
          {type:2,data:{
              "title":"远程云教育平台",
              "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
              "place":3,//结构0图上 1图下 2图左 3图右
              "type":0,//0默认 1圆角
              "list":[
              {
                "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
                "content":"搭建企业大学，构建SASS云学院"
              },
              ]
            }
          },
        ]
      },
    };
  },
  created() {
    // this.systemFalgObj = this.$store.getters.getUserValue;
    //this.getData();
    window.location.reload();
  },
  mounted() {},
  methods: {
    getData(){
      var that = this;
      that.axios
        .get(interfaceObj.defaultpage)
        .then((res) => {
          // this.$store.commit("setUserValue", res.data.data);
          that.homeData = res.data.data;
          that.navStatus = true;
          console.log("that.homeData",that.homeData);
      });
    }
  }
}
</script>
<style lang="scss">
.home{
  width:100%;
}
</style>
